import { ICellRendererParams } from 'ag-grid-enterprise';
import React from 'react';
import { PercentText } from '../input-formatters/PercentText';

export const AgGridPercentCell = ({ value }: ICellRendererParams) => {
  if (Number.isNaN(value) || typeof value === 'undefined') {
    return;
  }
  return <PercentText value={value} />;
};
